import { useCallback } from "react";

import { calendarUpdatedVar } from "@cache/cache";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherCalendarUpdated({
  channelName,
}: {
  channelName: string;
}) {
  const handleCalendarUpdated = useCallback(() => {
    calendarUpdatedVar(Date.now());
  }, []);

  usePusher(channelName, "calendar_updated", handleCalendarUpdated);

  return null;
}
